<template>
  <el-container class="login-register-main">
    <!--回车提交表单-->
    <el-form label-width="" ref="loginForm" :model="loginForm" :rules="loginRules" @click.enter.prevent="handleLogin">
      <el-row type="flex" justify="center" style="color: #5e6d82; font-size: 14px;">
        <span>微信扫码获取动态登陆码</span>
      </el-row>

      <el-row class="login-title" type="flex" justify="center">
        <el-col :sapn="24"><img src="@/assets/public.jpg" /></el-col>
      </el-row>

      <el-form-item prop="verifyCode">
        <el-input type="text" v-model="loginForm.verifyCode" auto-complete="off" maxlength="6" placeholder="请输入验证码"
          clearable>
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
        </el-input>
      </el-form-item>

      <el-form-item style="width: 100%">
        <el-button type="primary" native-type="submit" style="width: 100%;" :loading="loading" @click.native.prevent="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
  import {
    fetchLoginData
  } from '@/api/index';

  export default {
    name: "Login",
    data() {
      return {
        loginRules: {
          verifyCode: [{
              required: true,
              trigger: "change",
              message: "验证码不能为空"
            },
            {
              min: 4,
              max: 6,
              message: '长度在 4 到 6 个字符',
              trigger: 'blur'
            }
          ],
        },
        loginForm: {
          verifyCode: ''
        },
        loading: false
      }
    },
    methods: {
      handleLogin() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.signUp();
          }
        });
      },
      signUp() {
        this.loading = true;
        fetchLoginData({
            params: {
              "verifyCode": this.loginForm.verifyCode
            }
          }) // axios 请求在这里
          .then((res) => {
            let result = res.data;
            console.info(result);
            if (result.success === true) {
              this.$message({
                type: 'info',
                message: '登录成功'
              });
              this.$store.dispatch('login', result.data.token); // 向 vuex 传递用户名
              this.$store.commit('getIndex', []);
              this.$store.commit('getHome', []);
              this.$router.push({
                path: this.redirect || "/"
              });
            } else {
              this.$alert(result.msg, {
                type: 'error',
                callback: action => {
                  console.log(this.$store.state);
                  this.loading = false;
                }
              });
            };
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    watch: {
      $route: {
        handler: function(route) {
          this.redirect = route.query && route.query.redirect;
        },
        immediate: true
      }
    },
    /*导航守卫，只要跳转至本页面 用户登录信息就会被清空*/
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        vm.$store.dispatch('logout', false);
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue